"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __asyncValues = (this && this.__asyncValues) || function (o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.genLeapSporeFromCkbToBtcRawTx = exports.buildSporeBtcTimeCellsSpentTx = exports.genLeapSporeFromBtcToCkbVirtualTx = void 0;
const utils_1 = require("../utils");
const rgbpp_1 = require("../utils/rgbpp");
const constants_1 = require("../constants");
const spore_1 = require("../utils/spore");
const error_1 = require("../error");
const ckb_sdk_utils_1 = require("@nervosnetwork/ckb-sdk-utils");
const base_1 = require("@ckb-lumos/base");
const rgbpp_2 = require("../rgbpp");
/**
 * Generate the virtual ckb transaction for leaping spore from BTC to CKB
 * @param collector The collector that collects CKB live cells and transactions
 * @param sporeRgbppLockArgs The spore rgbpp cell lock script args whose data structure is: out_index | bitcoin_tx_id
 * @param sporeTypeBytes The spore type script serialized bytes
 * @param toCkbAddress The receiver ckb address
 * @param isMainnet True is for BTC and CKB Mainnet, false is for BTC and CKB Testnet(see btcTestnetType for details about BTC Testnet)
 * @param witnessLockPlaceholderSize(Optional) The WitnessArgs.lock placeholder bytes array size and the default value is 5000
 * @param ckbFeeRate(Optional) The CKB transaction fee rate, default value is 1100
 * @param btcTestnetType(Optional) The Bitcoin Testnet type including Testnet3 and Signet, default value is Testnet3
 */
const genLeapSporeFromBtcToCkbVirtualTx = (_a) => __awaiter(void 0, [_a], void 0, function* ({ collector, sporeRgbppLockArgs, sporeTypeBytes, toCkbAddress, isMainnet, witnessLockPlaceholderSize, ckbFeeRate, btcTestnetType, }) {
    const sporeRgbppLock = Object.assign(Object.assign({}, (0, constants_1.getRgbppLockScript)(isMainnet, btcTestnetType)), { args: (0, utils_1.append0x)(sporeRgbppLockArgs) });
    const sporeCells = yield collector.getCells({ lock: sporeRgbppLock, isDataMustBeEmpty: false });
    (0, spore_1.throwErrorWhenSporeCellsInvalid)(sporeCells, sporeTypeBytes, isMainnet);
    const sporeCell = sporeCells[0];
    const inputs = [
        {
            previousOutput: sporeCell.outPoint,
            since: '0x0',
        },
    ];
    const toLock = (0, ckb_sdk_utils_1.addressToScript)(toCkbAddress);
    const outputs = [
        Object.assign(Object.assign({}, sporeCell.output), { lock: (0, rgbpp_1.genBtcTimeLockScript)(toLock, isMainnet, btcTestnetType) }),
    ];
    const outputsData = [sporeCell.outputData];
    const cellDeps = [
        ...(yield (0, utils_1.fetchTypeIdCellDeps)(isMainnet, { rgbpp: true }, btcTestnetType)),
        (0, constants_1.getSporeTypeDep)(isMainnet),
    ];
    const sporeCoBuild = (0, spore_1.generateSporeTransferCoBuild)([sporeCell], outputs);
    const witnesses = [constants_1.RGBPP_WITNESS_PLACEHOLDER, sporeCoBuild];
    const ckbRawTx = {
        version: '0x0',
        cellDeps,
        headerDeps: [],
        inputs,
        outputs,
        outputsData,
        witnesses,
    };
    let changeCapacity = BigInt(sporeCell.output.capacity);
    const txSize = (0, ckb_sdk_utils_1.getTransactionSize)(ckbRawTx) + (witnessLockPlaceholderSize !== null && witnessLockPlaceholderSize !== void 0 ? witnessLockPlaceholderSize : constants_1.RGBPP_TX_WITNESS_MAX_SIZE);
    const estimatedTxFee = (0, utils_1.calculateTransactionFee)(txSize, ckbFeeRate);
    changeCapacity -= estimatedTxFee;
    ckbRawTx.outputs[ckbRawTx.outputs.length - 1].capacity = (0, utils_1.append0x)(changeCapacity.toString(16));
    const virtualTx = Object.assign({}, ckbRawTx);
    const commitment = (0, rgbpp_1.calculateCommitment)(virtualTx);
    return {
        ckbRawTx,
        commitment,
        sporeCell,
        needPaymasterCell: false,
        sumInputsCapacity: sporeCell.output.capacity,
    };
});
exports.genLeapSporeFromBtcToCkbVirtualTx = genLeapSporeFromBtcToCkbVirtualTx;
/**
 * Collect btc time cells and spend them to create spore cells for the specific lock scripts in the btc time lock args
 * The btc time lock args data structure is: lock_script | after | new_bitcoin_tx_id
 * @param btcTimeCells The BTC time cells of spore
 * @param btcAssetsApi BTC Assets Api
 * @param isMainnet True is for BTC and CKB Mainnet, false is for BTC and CKB Testnet(see btcTestnetType for details about BTC Testnet)
 * @param btcTestnetType(Optional) The Bitcoin Testnet type including Testnet3 and Signet, default value is Testnet3
 */
const buildSporeBtcTimeCellsSpentTx = (_a) => __awaiter(void 0, [_a], void 0, function* ({ btcTimeCells, btcAssetsApi, isMainnet, btcTestnetType, }) {
    var _b, e_1, _c, _d;
    const sortedBtcTimeCells = btcTimeCells.sort(rgbpp_1.compareInputs);
    const inputs = sortedBtcTimeCells.map((cell) => ({
        previousOutput: cell.outPoint,
        since: '0x0',
    }));
    const outputs = sortedBtcTimeCells.map((cell) => ({
        lock: (0, rgbpp_1.lockScriptFromBtcTimeLockArgs)(cell.output.lock.args),
        type: cell.output.type,
        capacity: cell.output.capacity,
    }));
    const outputsData = sortedBtcTimeCells.map((cell) => cell.outputData);
    const cellDeps = [
        ...(yield (0, utils_1.fetchTypeIdCellDeps)(isMainnet, { btcTime: true }, btcTestnetType)),
        (0, constants_1.getSporeTypeDep)(isMainnet),
    ];
    const witnesses = [];
    const lockArgsSet = new Set();
    const cellDepsSet = new Set();
    try {
        for (var _e = true, sortedBtcTimeCells_1 = __asyncValues(sortedBtcTimeCells), sortedBtcTimeCells_1_1; sortedBtcTimeCells_1_1 = yield sortedBtcTimeCells_1.next(), _b = sortedBtcTimeCells_1_1.done, !_b; _e = true) {
            _d = sortedBtcTimeCells_1_1.value;
            _e = false;
            const btcTimeCell = _d;
            if (lockArgsSet.has(btcTimeCell.output.lock.args)) {
                witnesses.push('0x');
                continue;
            }
            lockArgsSet.add(btcTimeCell.output.lock.args);
            const { btcTxId, after } = (0, rgbpp_1.btcTxIdAndAfterFromBtcTimeLockArgs)(btcTimeCell.output.lock.args);
            const result = yield btcAssetsApi.getRgbppSpvProof(btcTxId, after);
            const { spvClient, proof } = (0, rgbpp_1.transformSpvProof)(result);
            if (!cellDepsSet.has((0, ckb_sdk_utils_1.serializeOutPoint)(spvClient))) {
                cellDeps.push((0, rgbpp_1.buildSpvClientCellDep)(spvClient));
                cellDepsSet.add((0, ckb_sdk_utils_1.serializeOutPoint)(spvClient));
            }
            const btcTimeWitness = (0, utils_1.append0x)((0, ckb_sdk_utils_1.serializeWitnessArgs)({ lock: (0, rgbpp_2.buildBtcTimeUnlockWitness)(proof), inputType: '', outputType: '' }));
            witnesses.push(btcTimeWitness);
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (!_e && !_b && (_c = sortedBtcTimeCells_1.return)) yield _c.call(sortedBtcTimeCells_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    const sporeCoBuild = (0, spore_1.generateSporeTransferCoBuild)(sortedBtcTimeCells, outputs);
    witnesses.push(sporeCoBuild);
    const ckbTx = {
        version: '0x0',
        cellDeps,
        headerDeps: [],
        inputs,
        outputs,
        outputsData,
        witnesses,
    };
    return ckbTx;
});
exports.buildSporeBtcTimeCellsSpentTx = buildSporeBtcTimeCellsSpentTx;
/**
 * Generate the virtual ckb transaction for leaping spore from CKB to BTC
 * @param collector The collector that collects CKB live cells and transactions
 * @param sporeRgbppLockArgs The spore rgbpp cell lock script args whose data structure is: out_index | bitcoin_tx_id
 * @param sporeTypeBytes The spore type script serialized bytes
 * @param toCkbAddress The receiver ckb address
 * @param isMainnet True is for BTC and CKB Mainnet, false is for BTC and CKB Testnet
 * @param witnessLockPlaceholderSize(Optional) The WitnessArgs.lock placeholder bytes array size and the default value is 5000
 * @param ckbFeeRate(Optional) The CKB transaction fee rate, default value is 1100
 */
const genLeapSporeFromCkbToBtcRawTx = (_a) => __awaiter(void 0, [_a], void 0, function* ({ collector, sporeTypeBytes, fromCkbAddress, toRgbppLockArgs, isMainnet, witnessLockPlaceholderSize, ckbFeeRate, btcTestnetType, }) {
    const fromLock = (0, ckb_sdk_utils_1.addressToScript)(fromCkbAddress);
    const sporeType = base_1.blockchain.Script.unpack(sporeTypeBytes);
    const sporeCells = yield collector.getCells({ lock: fromLock, type: sporeType });
    if (!sporeCells || sporeCells.length === 0) {
        throw new error_1.NoRgbppLiveCellError('No spore rgbpp cells found with the spore rgbpp lock args and spore type script');
    }
    const sporeCell = sporeCells[0];
    const inputs = [
        {
            previousOutput: sporeCell.outPoint,
            since: '0x0',
        },
    ];
    const outputs = [
        Object.assign(Object.assign({}, sporeCell.output), { lock: Object.assign(Object.assign({}, (0, constants_1.getRgbppLockScript)(isMainnet, btcTestnetType)), { args: (0, utils_1.append0x)(toRgbppLockArgs) }) }),
    ];
    const outputsData = [sporeCell.outputData];
    const cellDeps = [(0, constants_1.getSporeTypeDep)(isMainnet)];
    const sporeCoBuild = (0, spore_1.generateSporeTransferCoBuild)([sporeCell], outputs);
    const witnesses = [constants_1.RGBPP_WITNESS_PLACEHOLDER, sporeCoBuild];
    const ckbRawTx = {
        version: '0x0',
        cellDeps,
        headerDeps: [],
        inputs,
        outputs,
        outputsData,
        witnesses,
    };
    let changeCapacity = BigInt(sporeCell.output.capacity);
    const txSize = (0, ckb_sdk_utils_1.getTransactionSize)(ckbRawTx) + (witnessLockPlaceholderSize !== null && witnessLockPlaceholderSize !== void 0 ? witnessLockPlaceholderSize : constants_1.RGBPP_TX_WITNESS_MAX_SIZE);
    const estimatedTxFee = (0, utils_1.calculateTransactionFee)(txSize, ckbFeeRate);
    changeCapacity -= estimatedTxFee;
    ckbRawTx.outputs[ckbRawTx.outputs.length - 1].capacity = (0, utils_1.append0x)(changeCapacity.toString(16));
    return ckbRawTx;
});
exports.genLeapSporeFromCkbToBtcRawTx = genLeapSporeFromCkbToBtcRawTx;
